import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { Story } from '../components/Story';
import { Concept } from '../components/Concept';
import { Ritual } from '../components/Ritual';
import { Products } from '../components/Products';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-sand" data-id="element-137" data-mp="1ziqw5rtk64nu">
      <Header data-id="element-138" data-mp="1zk1uvd85cm83" />
      <main data-id="element-139" data-mp="24h0si5r0rbb1">
        <Hero data-id="element-140" data-mp="24gikkbuzv8na" />
        <Marquee data-id="element-141" data-mp="24g8wittifbk8" />
        <Story data-id="element-142" data-mp="24htrgkjqkwim" />
        <Concept data-id="element-143" data-mp="24hagxowf1aem" />
        <Ritual data-id="element-144" data-mp="24ivabb6zunaw" />
        <Products data-id="element-145" data-mp="29gd9waz4fq68" />
      </main>
      <Footer data-id="element-146" data-mp="29f2bkqog3ami" />
    </div>;
}